export default "__VITE_ASSET__DPj$PMVD__"